import axios from "axios";

export const AUTH_LOGOUT_EVENT = "auth:logout";

const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const clearAuthSession = () => {
  localStorage.removeItem("user");
  window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT));
};

api.interceptors.request.use(
  (config) => {
    if (!config.skipAuth) {
      const user = getStoredUser();
      if (user?.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const isAuthError = (error) => {
  if (!error.response) return false;
  const { status, data } = error.response;
  if (status !== 401) return false;
  const authErrors = [
    "UNAUTHENTICATED",
    "TOKEN_EXPIRED",
    "TOKEN_INVALID",
  ];
  return !data?.error || authErrors.includes(data.error);
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAuthError(error)) {
      clearAuthSession();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
